<!--
 * @Description: 
 * @Author: xuxiaofei
 * @Date: 2021-11-19 10:58:10
 * @LastEditors: 许晓飞 xuxiaofei.xxffe@sunyur.com
 * @LastEditTime: 2022-09-01 15:09:34
-->
<template>
  <div class="extend-field">
    <SyForm
		  :model="extendFieldForm"
			ref="fieldForm"
			style="font-size: 0"
			:label-width="`${labelWidth}px`"
			:pageType='pageType'
      :follow="follow"
			:span="span || 'auto'"
			:isText="true"
			:label-position="labelPosition"
		>
			<template v-for="item in fieldList">
				<SyFormItem
					v-if="!(project === 'supplier' && item.supplierDisplay === 0)"
					:label="item.fieldName"
					:key="item.sysFieldCode"
					:isText="true"
					:span="item.bannerDisplay === 1 ? '0' : (span || 'auto')"
				>
					<div class="field-value">
						<!-- 单行文本 -->
						<!-- 多行文本 -->
						<ReadText v-if="[1, 2].includes(item.fieldType)" :value="extendFieldForm[item.sysFieldCode] || '-'" computeHeight></ReadText>
						<!-- 单选 -->
						<ReadText v-if="item.fieldType === 3" :value="getRadioLabel(extendFieldForm[item.sysFieldCode], item.options)" computeHeight></ReadText>
						<!-- 多选 -->
						<ReadText v-if="item.fieldType === 4" :value="getMultipleLabel(extendFieldForm[item.sysFieldCode], item.options)" computeHeight></ReadText>
						<!-- 单选框 -->
						<ReadText v-if="item.fieldType === 5" :value="getRadioLabel(extendFieldForm[item.sysFieldCode], item.options)" computeHeight></ReadText>
						<!-- 图片 -->
						<template v-if="item.fieldType === 6">
							<img-field
								:imgList="extendFieldForm[item.sysFieldCode]"
								:itemInfo="item"
							/>
						</template>
						<!-- 附件 -->
						<SyAccessory
							v-if="item.fieldType === 7"
							size="mini"
							:ediTable="false"
							:onlyImage="false"
							:firstImgOnly="false"
							:isChunk="true"
							maxFileSize="5MB"
							:fileList="accessoryField(extendFieldForm[item.sysFieldCode])"
							></SyAccessory>
						</div>
				</SyFormItem>
			</template>
		</SyForm>
  </div>
</template>
        
<script>
/* eslint-disable */
import { Buttons, ReadText } from './../../../../../index.js'
import ImgField from './components/img-field.vue'
import SyAccessory from './../../../../basis/sy-accessory/sy-accessory.vue'
import { componentMessage } from './../../../utils'

export default {
  name: 'ExtendFieldDetaile',
	components: {
		Buttons,
		ImgField,
		SyAccessory,
		ReadText
	},
	props: {
    fieldList: {
			type: Array,
			default: () => []
		},
		// 一行几列
    span: {
      type: [Number, String]
    },
    // 页面类型,弹窗形式值为'popup'
    pageType: {
      type: String
    },
    // 表单是否跟随
    follow: {
      type: Boolean,
      default: false
    },
		labelWidth: {
			type: Number,
			default: 120
		},
		labelPosition: {
			type: String
		}
	},
  data () {		
    return {
      extendFieldForm: {},
			project: window.fe.project
    }
  },
  watch: {
		fieldList: {
      handler: function (newVal) {
			  this.transformData()
      },
      immediate: true
    }
	},
	computed: {
		// 获取单选的label
    getRadioLabel () {
			return function (code, options) {
				const find = options.find(i => i.code === code)
				return find?.value || '-'
			}
		},
		// 获取多选的label
		getMultipleLabel () {
			return function (codeArr, options) {
				let labelArr = []
				Array.isArray(codeArr) && codeArr.forEach(item => {
					const find = options.find(i => i.code === item)
					labelArr.push(find?.value || '-')
				})
				return labelArr.join()
			}
		},
		// 给附件列表补充filePath和url字段
		accessoryField () {
			return function (fieldArr) {
				Array.isArray(fieldArr) && fieldArr.forEach(i => {
          !i.filePath && i.url && this.$set(i, 'filePath', i.url)
					!i.url && i.filePath && this.$set(i, 'url', i.filePath) 
				})
				return fieldArr
			}
		}
	},
	created () {
		let verifyResult = componentMessage(['purchaser', 'supplier', 'mall'], '扩展字段详情组件 extend-field-detail')
		if (verifyResult) return
	},
  methods: {
    transformData () {
			this.extendFieldForm = {}
      this.fieldList.forEach((item, index) => {
				item.copySysFieldCode = item.sysFieldCode
				item.sysFieldCode = 'custom' + item.sysFieldCode
				// 设置form
				let value = null
				switch (item.fieldType) {
					// 文本类型 textVal  String类型 
					case 1:
					case 2:
						value = item?.fieldValue?.textVal || null
						break
					// optionsVals array类型
				  // 表单需要的是字符串
					case 3:
					case 5:
						if (item?.fieldValue?.optionsVals) {
              value = Array.isArray(item?.fieldValue?.optionsVals) ? item?.fieldValue?.optionsVals.join() : ''
						} else {
              Array.isArray(item.options) && item.options.forEach(optionItem => {
								optionItem.isDefault === 1 && (value = optionItem.code)
							})
						}
						break
					// 下拉多选
					case 4:
						if (item?.fieldValue?.optionsVals) {
              value = item?.fieldValue?.optionsVals || []
						} else {
							value = []
							Array.isArray(item.options) && item.options.forEach(optionItem => {
								optionItem.isDefault === 1 && (value.push(optionItem.code))
							})
						}
						break
					// fileVals  object
					// {
					// 	name: '',
					// 	url: ''
					// }
					case 6:
					case 7:
						if (item?.fieldValue?.fileVals) {
              value = item?.fieldValue?.fileVals || []
						} else {
              value = []
						}
						break
				}
				this.$set(this.extendFieldForm, item.sysFieldCode, value)
			})
			console.log(this.extendFieldForm)
		}
  }
}
</script>

<style lang="scss" scoped>
.extend-field {
	font-size: 14px;
	.field-value {
		word-wrap: break-word;
    word-break: normal;
	}
}
</style>
